import ResumeOverlay from './component'

export default ResumeOverlay
